module.exports = __webpack_public_path__ + "static/img/gjf.14d1a7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gjf.jpg
// module id = ljDa
// module chunks = 1